import React, { useEffect, useState } from 'react';
import { Grid, Backdrop, Snackbar, CircularProgress } from '@material-ui/core';
import useStyles from './AporteMejoraDocumentacionStyle';
import { texts, properties, formato } from './AporteMejoraDocumentacionData';
import useFunctions from './AporteMejoraDocumentacionFunction';
import SubirArchivoVoluntario from 'components/commons/subirArchivoVoluntario/SubirArchivoVoluntario';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import { compProperties, properties as appProperties } from './../../../AppData';
import { tipoFirma } from 'AppData';
import useApp from 'AppFunctions';
import { texts as textsFirma } from '../firmaSolicitud/FirmaSolicitudData';
import Dialogo from 'components/commons/dialogo/Dialogo';
import useSmsSignFunction from 'SmsSign/useSmsSignFunction';
import { useSelector } from 'react-redux';
import { properties as propertiesCloudConfig } from 'config/Config';
import useFunctions2 from '../aporteDocumentacion/AporteDocumentacionFunction';
import {properties as propertiesAporteDoc} from '../aporteDocumentacion/AporteDocumentacionData';
import {Alert} from '@material-ui/lab';

export default function AporteMejoraDocumentacion() {
    const {
        obtenerTituloPagina, volverABandeja, updateFormat, isPhoneVersion,
        documentosVoluntarios, handleOnDrop, handleChange, eliminarAnexoVoluntario,
        mostrarConfirmarErrorFichero, navegarBandeja, mostrarMensaje, textoError,
        mostrarError, disabledBotonFirmar, firmar, mostrarConfirmacionFirma,
        cerrarConfirmacionFirma, abrirConfirmacionFirma, isLoading, cerrarError,
        msgErrorPresentacion, mostrarErrorPresentacion, setMostrarErrorPresentacion,
        alerts, message, setMessage, setDocumentosVoluntarios
    } = useFunctions();
    const {getStorageProperties} =useFunctions2();
    const { obtenerTipoFirma } = useApp();
    const {
        enviarCodigoSms, codigoSms, handleChangeDialogo, handleHideDialogo,
        handleShowDialogo, validarCodigoSms, mostrarDialogo, atribInputDialog,
        codigoValido
    } = useSmsSignFunction();

    const { style } = useStyles(isPhoneVersion);
    const customStyle = style();

    const [idExpedienteTrewa, setIdExpedienteTrewa] = useState();

    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const procedimientoActual = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const TAM_MAX_ANEXO = propertiesCloudConfig['TAM_MAX_MEJ_DOCUMENTACION'];


    /**
    * @function obtenerProcedenciaConvocatoria Obtiene la procedencia de una convocatoria (PCT2 o PCT3)
    */
    const obtenerProcedenciaConvocatoria = () => {
        return ((procedimientoActual !== undefined && procedimientoActual !== '') &&
            (procedimientoActual.fromPct3 !== undefined && procedimientoActual.fromPct3 === true))
            ? 'PCT3' : 'PCT2';
    }

    //Contador para remontar el componente DropAreaZone
    const [remountCounter, setRemountCounter] = useState(0);
    // Estado inicial con el formato PDF
    const [formato, setFormato] = useState(['.pdf']);

    const limpiarTextoAnexoVoluntario = (clave) => {
      setDocumentosVoluntarios(prev =>
        prev.map(anexo =>
          anexo.id === clave
            ? { ...anexo,
                value: '',// Limpia el texto
                mostrarDropZone: false }
            : anexo
        )
      );
      setRemountCounter(prev => prev + 1);
    };

    useEffect(() => {
        let isMounted = true;
        getStorageProperties().then(() => {
            console.log("getStorageProperties resuelta");
            if (!isMounted) return;
            const formatosImagen = propertiesAporteDoc.ALLOWEDIMAGEFORMATS?.split(',') ?? [];
            const formatosVideo = propertiesAporteDoc.ALLOWEDVIDEOFORMATS?.split(',') ?? [];
            const formatosTotales = ['.pdf', ...formatosImagen, ...formatosVideo];
            setFormato(formatosTotales);
            console.log("Formatos detectados:", formatosTotales);
        }).catch(error => {
            console.error("Error en getStorageProperties:", error);
        });
        obtenerTituloPagina();
        updateFormat();

        // Añadir un documento voluntario inicial vacío
        const documentoVoluntario = {
            id: Date.now(),
            mostrarDropZone: false,
            value: "",
            mostrarDocAnexo: false,
            tamDoc: "",
            pdf: "",
            img: properties.PATH_IMG_PDF
        };

        documentosVoluntarios.push(documentoVoluntario);
        mostrarIdExpediente();
        return () => {
            isMounted = false;
          };
     }, []);

    const mostrarIdExpediente = () => {
        if (solicitudActual && solicitudActual.idExpediente) {
            setIdExpedienteTrewa(`(${solicitudActual.idExpediente})`);
        }
    }

    useEffect(() => {
        if (mostrarErrorPresentacion) {
            const timer = setTimeout(() => {
                setMostrarErrorPresentacion(false);
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [mostrarErrorPresentacion]);

    // Efecto que se ejecuta cuando se trate de una firma SMS y se haya validado de forma correcta el código SMS insertado por el ciudadano
    useEffect(() => {
        if (codigoValido === true) {
            firmar();
        }
    }, [codigoValido]);

    useEffect(() => {
        window.addEventListener('resize', updateFormat);
        return () => window.removeEventListener('resize', updateFormat);
    }, []);

    return (
        <main>
            <Grid>
                <Grid className={customStyle.gridTitulo}>
                    <h2 className={customStyle.tituloPagina}>Mejora de documentación</h2>
                    <span className={customStyle.idExpediente}>
                        {obtenerProcedenciaConvocatoria() === 'PCT2'
                            ? idExpedienteTrewa
                            : solicitudActual.numeroExpediente}
                    </span>
                </Grid>
                <Grid className={customStyle.backgroundRectangle}>
                    <h3 className={customStyle.hclassText2}>
                        {texts.TEXTO_TAMAÑO_MAX_ANEXO}{TAM_MAX_ANEXO}{texts.TEXTO_MB}
                    </h3>
                    <Grid className={customStyle.gridSubirArchivo}>
                        {//Componente Generación de formularios
                            documentosVoluntarios.map(anexoV => (
                            <SubirArchivoVoluntario
                                key={`${anexoV.id}_${remountCounter}`}
                                img={anexoV.img}
                                tamMaximoArchivo={TAM_MAX_ANEXO}
                                formato={formato}
                                handleOnDrop={(files, rejectedFiles) =>
                                    handleOnDrop(files, rejectedFiles, null)
                                }
                                onChange={handleChange}
                                value={anexoV.value}
                                mostrarDrop={anexoV.mostrarDropZone}
                                mostrarDocAnexo={anexoV.mostrarDocAnexo}
                                tamDoc={anexoV.tamDoc}
                                bottonFunction={eliminarAnexoVoluntario}
                                handleRejection={(rejectedFiles) =>{
                                    mostrarConfirmarErrorFichero(rejectedFiles, TAM_MAX_ANEXO);
                                    limpiarTextoAnexoVoluntario(anexoV.id);
                                }}
                                pdf={anexoV.pdf}
                                poderVisualizar={true}
                            />
                        ))}
                    </Grid>
                </Grid>
                {mostrarErrorPresentacion && (
                    <div className={customStyle.mensajeErrorFlotante}>
                        {msgErrorPresentacion}
                    </div>
                )}
                {/*Confirmar error*/}
                <Confirmacion
                    accionConfirmacion={cerrarError}
                    titulo={texts.TITULO_ERROR}
                    mostrar={mostrarError}
                    isPhoneVersion={isPhoneVersion}
                    mensaje={textoError}
                    botonera={compProperties.SOLO_CERRAR}
                    quitarImg={false}
                    tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
                    isPopUpPdf={false}
                    textBotonConfirmarPersonalizado={false}
                    isImagenPersonalizada={true}
                    centrarContenido={true}
                    imagen={properties.IMAGEN_ERROR}
                    isTextoEnriquecido={true}
                />
                {/*Confirmar firma*/}
                <Confirmacion
                    accionConfirmacion={firmar}
                    accionDenegacion={compProperties.CONFIR_SIN_ACCION}
                    handleChange={cerrarConfirmacionFirma}
                    titulo={texts.TITULO_CONFIRMACION_FIRMA}
                    mostrar={mostrarConfirmacionFirma}
                    isPhoneVersion={isPhoneVersion}
                    mensaje={texts.MSG_CONFIRMACION_FIRMA}
                    botonera={compProperties.CONFIR_CANCELAR_ACEPTAR}
                    quitarImg={false}
                    tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
                    isPopUpPdf={false}
                    textBotonConfirmarPersonalizado={false}
                    centrarContenido={true}
                    isImagenPersonalizada={false}
                    isTextoEnriquecido={true}
                />
                {/**Confirmar aporte ok */}
                <Confirmacion
                    accionConfirmacion={navegarBandeja}
                    titulo={texts.TITULO_APORTE_OK}
                    mostrar={mostrarMensaje}
                    isPhoneVersion={isPhoneVersion}
                    mensaje={texts.MSG_APORTE_OK}
                    botonera={compProperties.CONFIR_SOLO_ACEPTAR}
                    quitarImg={false}
                    tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
                    isPopUpPdf={false}
                    textBotonConfirmarPersonalizado={false}
                    isImagenPersonalizada={true}
                    centrarContenido={true}
                    imagen={properties.IMAGEN_APORTE_OK}
                    isTextoEnriquecido={true}
                />
                {/* Diálogo firma SMS */}
                <Dialogo
                    titulo={textsFirma.TITULO_DIALOGO}
                    texto={textsFirma.TEXTO_DIALOGO}
                    objAtributosInput={{ ...atribInputDialog }}
                    valueInput={codigoSms}
                    onChangeInput={handleChangeDialogo}
                    placeholderInput={textsFirma.PLACEHOLDER_DIALOGO}
                    handleAccion={validarCodigoSms}
                    show={mostrarDialogo}
                    handleShow={handleShowDialogo}
                    handleHide={handleHideDialogo}
                    textBtnCancela={textsFirma.BTN_CANCELAR_DIALOGO}
                    textBtnAccion={textsFirma.BTN_ACCION_DIALOGO}
                />
                {/* Botonera final */}
                <Grid container className={customStyle.gridBoton} justify='flex-end' spacing={1}>
                    <button className={customStyle.botonVolver} onClick={volverABandeja}>{texts.TEXT_BOTON}</button>
                    <button className={customStyle.botonFirma} disabled={disabledBotonFirmar}
                        onClick={obtenerTipoFirma(infoUsuario, convocatoriaSeleccionada) === tipoFirma.FIRMA_SMS ? enviarCodigoSms : abrirConfirmacionFirma}>
                        {obtenerTipoFirma(infoUsuario, convocatoriaSeleccionada) === tipoFirma.FIRMA_SMS ? texts.TEXT_FIRMAR_SMS : texts.TEXT_FIRMAR}
                    </button>
                </Grid>
            </Grid>

            {/* Loading general */}
            <Backdrop className={customStyle.classBackdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {alerts.map(m => (
              <Snackbar open={message.msg} autoHideDuration={5000} onClose={() => setMessage({ severity: "", msg: "" })}>
                <Alert
                  severity={message.severity}
                  variant="filled"
                >
                  {message.msg}
                </Alert>
              </Snackbar>
            ))}
        </main>
    );
}